export class Bank {
  id = 0;
  code: string = null;
  name: string = null;
  shortName: string = null;
}
